import { getInternalMetas } from "../../internal/metas.js";
import { isEmpty, isNull } from "../../utils/is.js";
import { deepEqual } from "../../utils/deepEqual.js";
import { getCurrentTimestamp, timestampToIsoString } from "../../utils/date.js";
import { stringifyObjectValues } from "../../utils/json.js";
import { captureMetas } from "../../metas/capture.js";
import _objectSpread2 from "../../_virtual/_@oxc-project_runtime@0.150.0/helpers/esm/objectSpread2.js";
import "../../transports/const.js";
import { addItemToUserActionBuffer } from "../userActions/initialize.js";
//#region src/api/measurements/initialize.ts
function initializeMeasurementsAPI({ internalLogger, config, metas, transports, tracesApi, userActionsApi }) {
	internalLogger.debug("Initializing measurements API");
	let lastPayload = null;
	const pushMeasurement = (payload, { skipDedupe, context, spanContext, timestampOverwriteMs } = {}) => {
		try {
			if (!getInternalMetas(metas).shouldCapture()) return;
			const ctx = stringifyObjectValues(context);
			const measurement = _objectSpread2(_objectSpread2({}, payload), {}, {
				trace: spanContext ? {
					trace_id: spanContext.traceId,
					span_id: spanContext.spanId
				} : tracesApi.getTraceContext(),
				timestamp: timestampOverwriteMs ? timestampToIsoString(timestampOverwriteMs) : getCurrentTimestamp(),
				context: isEmpty(ctx) ? void 0 : ctx
			});
			const testingPayload = {
				type: measurement.type,
				values: measurement.values,
				context: measurement.context
			};
			if (!skipDedupe && config.dedupe && !isNull(lastPayload) && deepEqual(testingPayload, lastPayload)) {
				internalLogger.debug("Skipping measurement push because it is the same as the last one\n", measurement);
				return;
			}
			const previousPayload = lastPayload;
			const meta = captureMetas(metas);
			if (lastPayload !== previousPayload && !skipDedupe && config.dedupe && deepEqual(testingPayload, lastPayload)) return;
			lastPayload = testingPayload;
			const item = {
				type: "measurement",
				payload: measurement,
				meta
			};
			internalLogger.debug("Pushing measurement\n", item);
			if (!addItemToUserActionBuffer(userActionsApi.getActiveUserAction(), item)) transports.execute(item);
		} catch (err) {
			internalLogger.error("Error pushing measurement\n", err);
		}
	};
	return { pushMeasurement };
}
//#endregion
export { initializeMeasurementsAPI };

//# sourceMappingURL=initialize.js.map